import { useMemo } from 'react';

import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacet } from '#/modules/search/types/SearchFacet';

import { actionDateFacet } from './searchFacets/actionDateFacet';
import { doneInADayFacet } from './searchFacets/doneInADayFacet';
import { localeFacet } from './searchFacets/localeFacet';
import { locationTypeFacet } from './searchFacets/locationTypeFacet';
import { recencyFacet } from './searchFacets/recencyFacet';
import { volopAreasOfFocusFacet } from './searchFacets/volopAreasOfFocusFacet';
import { volopKeywordsFacet } from './searchFacets/volopKeywordsFacet';
import { volopSourceFacet } from './searchFacets/volopSourceFacet';
import { volopWelcomeFacet } from './searchFacets/volopWelcomeFacet';

/**
 * Only use this function if the code consuming the output does not rely on a stable object.
 *
 * If it does, use the hook instead
 */
export function unstableVolopSearchFacets(i18n: I18nFn) {
  return [
    locationTypeFacet(i18n),
    volopAreasOfFocusFacet(i18n),
    volopWelcomeFacet(i18n),
    volopSourceFacet(i18n),
    actionDateFacet(i18n),
    volopKeywordsFacet(i18n),
    localeFacet(i18n),
    doneInADayFacet(i18n),
    recencyFacet(i18n),
  ] as const satisfies SearchFacet[];
}

export function useSearchFacetsVolop(i18n: I18nFn) {
  const volopSearchFacets = useMemo(
    () => unstableVolopSearchFacets(i18n),
    [i18n],
  );

  return { volopSearchFacets };
}
